import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { of } from 'rxjs';
import { DeleteResultDto } from '../api/dto/delete-result-dto';
import { DialogWrapperAction, DialogWrapperDataOut } from '../data-source/dialog-wrapper-data-source';
import { ConfirmDialog, ConfirmDialogDataIn } from '../dialog/confirm/confirm.dialog';
import { DeleteDialog, DeleteDialogDataIn } from '../dialog/delete/delete.dialog';

function isDeleteResult(obj: unknown): obj is DeleteResultDto {
  return typeof obj == 'object' && obj != null && 'remainingObjects' in obj && Array.isArray(obj.remainingObjects);
}
@Injectable({ providedIn: 'root' })
export class DeleteService {
  private dialog = inject(MatDialog);

  public delete<TItem, TId extends number | string>(data: DeleteDialogDataIn<TItem, TId>) {
    const dialog$ = this.dialog.open<
      DeleteDialog<TItem, TId>,
      DeleteDialogDataIn<TItem, TId>,
      DialogWrapperDataOut<DeleteResultDto | null>
    >(DeleteDialog, {
      data: data,
    });
    dialog$.afterClosed().subscribe((result) => {
      if (
        result &&
        result.action === DialogWrapperAction.action &&
        isDeleteResult(result.saveResult) &&
        result.saveResult.remainingObjects.length !== 0
      ) {
        this.dialog.open<ConfirmDialog, ConfirmDialogDataIn, DialogWrapperDataOut<DeleteResultDto>>(ConfirmDialog, {
          data: {
            title:
              result.saveResult.remainingObjects?.length === 1
                ? $localize`:@@general.couldNotRemoveElementTitle:Folgendes Element konnte nicht gelöscht werden`
                : $localize`:@@general.couldNotRemoveElementsTitle:Folgende Elemente konnten nicht gelöscht werden`,
            content: result.saveResult.remainingObjects
              .map((id) => {
                const item = data.items.find((obj) => data.idFn(obj) === id);
                return item ? data.nameFn(item) : '???';
              })
              .join(', '),
            actionFn: () => of(null),
          },
        });
      }
    });
    return dialog$;
  }
}
